import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import CustomTooltip from 'pages/parts/CustomTooltip'

import { formatDate, formatMoney, returnSign } from 'helpers/helpers'
import { httpOk, GET } from 'helpers/api'

// «Подписки точек»: сколько платит точка и за что, какие модули у неё работают.
// Одна страница на админку и кабинет партнёра — отличаются только адресом API.
// Какие точки видит партнёр, решает сервер по токену.

const thStyle = {
	whiteSpace: 'nowrap',
	verticalAlign: 'middle',
}

const moduleThStyle = {
	writingMode: 'vertical-rl',
	transform: 'rotate(180deg)',
	whiteSpace: 'nowrap',
	fontSize: '12px',
	padding: '8px 4px',
	verticalAlign: 'bottom',
}

const mutedStyle = {
	color: 'var(--dark-text-muted, #8791a1)',
	fontSize: '12px',
}

// Селекты внутри выпадающего фильтра: список открывается поверх, а не внутри меню
const SELECT_PORTAL_PROPS = {
	menuPosition: 'fixed',
	menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
	menuPlacement: 'auto',
	styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
}

function PosSubscriptions({ mode = 'admin' }) {
	const { t } = useTranslation()
	const baseUrl = mode === 'partner' ? '/partner/pos-subscriptions' : '/admin/pos-subscriptions'

	const statuses = [
		{ 'id': 1, 'name': t('active') },
		{ 'id': -1, 'name': t('disconnected') },
	]

	const initialFilterData = {
		search: '',
		status_ids: statuses,
		tariff: null,
		partner: null,
		with_modules: [],
		without_modules: [],
		order_by: '',
	}

	const [filterData, setFilterData] = useState(initialFilterData)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [helper, setHelper] = useState({ tariffs: [], services: [] })
	// Админу — все партнёры, партнёру — он сам и подчинённые (ветку проверяет и сервер)
	const [partners, setPartners] = useState([])
	const [data, setData] = useState({ data: [], modules: [], total: 0, totals: {} })
	const [pagination, setPagination] = useState({ url: baseUrl, response: null })

	const moduleOptions = (data.modules || []).map((module) => ({
		key: module.key,
		name: t('pos_sub_module_' + module.key, { defaultValue: module.name }),
	}))

	async function searchWithFilter(page = 0, nextFilterData = filterData) {
		var url = baseUrl
		if (nextFilterData.search)
			url += returnSign(url) + 'search=' + encodeURIComponent(nextFilterData.search)
		if (nextFilterData.status_ids?.length)
			url += returnSign(url) + 'status_ids=' + nextFilterData.status_ids.map(item => item.id).join(',')
		if (nextFilterData.tariff)
			url += returnSign(url) + 'tariff_id=' + nextFilterData.tariff.id
		if (nextFilterData.partner)
			url += returnSign(url) + 'partner_id=' + nextFilterData.partner.id
		if (nextFilterData.with_modules?.length)
			url += returnSign(url) + 'with_modules=' + nextFilterData.with_modules.map(item => item.key).join(',')
		if (nextFilterData.without_modules?.length)
			url += returnSign(url) + 'without_modules=' + nextFilterData.without_modules.map(item => item.key).join(',')
		if (nextFilterData.order_by)
			url += returnSign(url) + 'order_by=' + nextFilterData.order_by
		if (page)
			url += returnSign(url) + 'page=' + page

		const response = await GET(url, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ url: url, response: response.data })
		}
		setDropdownIsOpen(false)
	}

	async function getHelper() {
		const response = await GET(baseUrl + '/helper', {}, { loader: false })
		if (httpOk(response)) setHelper(response.data)
	}

	async function getPartners() {
		const response = await GET(mode === 'partner' ? '/partner/helper/partners' : '/admin/helper/partners', {}, { loader: false })
		if (httpOk(response)) setPartners(response.data)
	}

	function resetFilter() {
		setFilterData(initialFilterData)
		searchWithFilter(0, initialFilterData)
	}

	// Сколько фильтров выбрано — видно на кнопке, не раскрывая её
	function filterCount() {
		var count = 0
		if (filterData.tariff) count++
		if (filterData.partner) count++
		if (filterData.with_modules?.length) count++
		if (filterData.without_modules?.length) count++
		if (filterData.status_ids?.length !== statuses.length) count++
		return count
	}

	function toggleOrder(column) {
		const [currentColumn, currentDirection] = (filterData.order_by || '').split(',')
		const direction = currentColumn === column && currentDirection === 'desc' ? 'asc' : 'desc'
		const nextFilterData = { ...filterData, 'order_by': `${column},${direction}` }
		setFilterData(nextFilterData)
		searchWithFilter(0, nextFilterData)
	}

	function renderOrder(column) {
		const [currentColumn, currentDirection] = (filterData.order_by || '').split(',')
		if (currentColumn !== column) return <i className="uil uil-sort text-muted"></i>
		return currentDirection === 'desc' ? <i className="uil uil-arrow-down"></i> : <i className="uil uil-arrow-up"></i>
	}

	// Подсказка к кружку: почему модуль работает или нет
	function moduleHint(module, state) {
		const name = t('pos_sub_module_' + module.key, { defaultValue: module.name })
		const price = state.price ? formatMoney(state.price) : ''
		var reason = ''
		switch (state.state) {
			case 'plan':
				reason = t('pos_sub_state_plan')
				break
			case 'free':
				reason = t('pos_sub_state_free')
				break
			case 'trial':
				reason = t('pos_sub_state_trial') + (state.until ? ' ' + formatDate(state.until, 'dd.MM.yyyy') : '')
				break
			case 'paid':
				reason = t('pos_sub_state_paid') + (price ? ', ' + price : '') + (state.until ? ', ' + t('until') + ' ' + formatDate(state.until, 'dd.MM.yyyy') : '')
				break
			case 'grace':
				reason = t('pos_sub_state_grace') + (price ? ', ' + price : '')
				break
			case 'brand':
				reason = t('pos_sub_state_brand') + ' #' + state.via_pos_id
				break
			case 'unpaid':
				reason = t('pos_sub_state_unpaid') + (price ? ', ' + price : '')
				break
			default:
				reason = t('pos_sub_state_off')
		}
		return `${name}: ${reason}`
	}

	function renderModuleSelect(key, label) {
		return (
			<div className="form-group col-md-12">
				<label>{label}</label>
				<Select
					{...SELECT_PORTAL_PROPS}
					isMulti
					isClearable
					options={moduleOptions}
					value={filterData[key]}
					onChange={(options) => setFilterData({ ...filterData, [key]: options || [] })}
					placeholder={t('all')}
					noOptionsMessage={() => t('list_empty')}
					getOptionLabel={(option) => option.name}
					getOptionValue={(option) => option.key}
				/>
			</div>
		)
	}

	useEffect(() => {
		getHelper()
		getPartners()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex flex-wrap justify-content-between align-items-center mb-2">
				<h4 className="vertical-center h-100">
					{t('pos_subscriptions')} [{data.total || 0}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap gap-2 mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									onSearchChange={(search) => {
										const nextFilterData = { ...filterData, 'search': search }
										setFilterData(nextFilterData)
										searchWithFilter(0, nextFilterData)
									}}>
								</FilterSearch>
							</div>
							<Dropdown autoClose="outside" onToggle={(isOpen) => setDropdownIsOpen(!!isOpen)} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}{filterCount() > 0 ? ` (${filterCount()})` : ''}
								</Dropdown.Toggle>
								<Dropdown.Menu className="dropdown-filter" onClick={(e) => e.stopPropagation()}>
									<div className="row">
										<div className="form-group col-md-12">
											<label>{t('status')}</label>
											<Select
												{...SELECT_PORTAL_PROPS}
												isMulti
												options={statuses}
												value={filterData.status_ids}
												onChange={(options) => setFilterData({ ...filterData, 'status_ids': options || [] })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-md-12">
											<label>{t('pos_sub_package')}</label>
											<Select
												{...SELECT_PORTAL_PROPS}
												isClearable
												options={helper.tariffs}
												value={filterData.tariff}
												onChange={(option) => setFilterData({ ...filterData, 'tariff': option })}
												placeholder={t('all')}
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-md-12">
											<label>{t('partner')}</label>
											{/* Логин рядом с именем: у партнёров бывают одинаковые имена */}
											<Select
												{...SELECT_PORTAL_PROPS}
												isClearable
												options={partners}
												value={filterData.partner}
												onChange={(option) => setFilterData({ ...filterData, 'partner': option })}
												placeholder={t('all')}
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => (option.name || option.login) + ' (' + option.login + ')'}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="row">
										{renderModuleSelect('with_modules', t('pos_sub_with_modules'))}
									</div>
									<div className="row">
										{renderModuleSelect('without_modules', t('pos_sub_without_modules'))}
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary" onClick={() => resetFilter()}>
													{t('reset')}
												</button>
												<button className="btn btn-primary" onClick={() => searchWithFilter(0)}>
													{t('apply_action')}
												</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
						<div className="d-flex align-items-center" style={mutedStyle}>
							<span className="bg-primary bg-border me-1"></span> {t('pos_sub_legend_on')}
							<span className="bg-danger bg-border ms-3 me-1"></span> {t('pos_sub_legend_off')}
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={thStyle}>#</th>
									<th style={thStyle}>ID</th>
									<th style={thStyle}>{t('pos')}</th>
									<th style={thStyle}>{t('pos_sub_package')}</th>
									<th style={thStyle} className="text-end cursor" onClick={() => toggleOrder('tariff')}>
										{t('tariff')} {renderOrder('tariff')}
									</th>
									<th style={thStyle} className="cursor" onClick={() => toggleOrder('services_total')}>
										{t('pos_sub_extra_services')} {renderOrder('services_total')}
									</th>
									<th style={thStyle} className="text-end cursor" onClick={() => toggleOrder('monthly_total')}>
										{t('pos_sub_monthly_total')} {renderOrder('monthly_total')}
									</th>
									{data.modules?.map((module) => (
										<th key={module.key} className="text-center" style={moduleThStyle}>
											{t('pos_sub_module_' + module.key, { defaultValue: module.name })}
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								{data.data?.map((item) => (
									<tr key={item.id} className={Number(item.status) !== 1 ? 'text-muted' : ''}>
										<td>{item.row_number}</td>
										<td>{item.id}</td>
										<td>
											<div className="fw-semibold">{item.name}</div>
											<div style={mutedStyle}>{item.login}</div>
										</td>
										<td className="text-nowrap">{item.tariff_plan_name || <span style={mutedStyle}>—</span>}</td>
										<td className="text-end text-nowrap">{formatMoney(item.tariff)}</td>
										<td>
											{item.services?.length > 0
												? item.services.map((service) => (
													<div key={service.service_id} className="text-nowrap" style={{ fontSize: '13px' }}>
														{t('pos_sub_module_' + service.code, { defaultValue: service.name })}
														{' — '}
														<span className={service.state === 'unpaid' ? 'text-danger' : ''}>
															{Number(service.price) > 0 ? formatMoney(service.price) : t('pos_sub_free')}
														</span>
													</div>
												))
												: <span style={mutedStyle}>—</span>
											}
										</td>
										<td className="text-end text-nowrap fw-semibold">{formatMoney(item.monthly_total)}</td>
										{data.modules?.map((module) => {
											const state = item.modules?.[module.key] || { on: false, state: 'off' }
											return (
												<td key={module.key} className="text-center">
													<CustomTooltip text={moduleHint(module, state)}>
														<span className={(state.on ? 'bg-primary' : 'bg-danger') + ' bg-border'}></span>
													</CustomTooltip>
												</td>
											)
										})}
									</tr>
								))}
								{data.data?.length > 0 &&
									<tr>
										<td colSpan={4}><b>{t('total')}</b></td>
										<td className="text-end text-nowrap"><b>{formatMoney(data.totals?.tariff)}</b></td>
										<td className="text-nowrap"><b>{formatMoney(data.totals?.services_total)}</b></td>
										<td className="text-end text-nowrap"><b>{formatMoney(data.totals?.monthly_total)}</b></td>
										<td colSpan={data.modules?.length || 0}></td>
									</tr>
								}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={(page) => searchWithFilter(page)}>
						</FilterPagination>
					}
				</div>
			</div>
		</>
	)
}

export default PosSubscriptions
